<template>
  <form action="" method="post" @submit.prevent="$emit('submit')" class="form">
    <Transition name="fade-fast">
      <div v-if="!submitted" :class="['form__auth', { form__error: error }]">
        <slot />
        <p v-if="error" class="form__error-message">{{ error }}</p>
        <button type="submit" :title="submitLabel" class="button --top" :disabled="!canSubmit">
          {{ submitLabel }}
        </button>
      </div>
    </Transition>
    <Loader v-if="submitted" form />
  </form>
</template>

<script>
import { Loader } from '@/components/small'

export default {
  name: 'AuthForm',
  components: { Loader },
  props: {
    canSubmit: {
      type: Boolean,
      required: true,
    },
    error: {
      type: String,
      default: null,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: (value) =>
        ['group_size', 'login', 'options', 'passwordForgotten', 'register'].includes(value),
    },
  },
  computed: {
    submitLabel() {
      return this.$beet.options.hunt.labels.auth[this.type] ?? this.$t('submit')
    },
  },
  emits: ['submit'],
}
</script>
